import type { Strapi4ResponseSingle } from '@nuxtjs/strapi/dist/runtime/types'
import { apiRequestWrapper } from '~/helpers/apiRequestWrapper'
import type { Company } from '~/types/Company'
import type { CompanyFileCategories } from '~/types/components/CompanyFileCategories'
import type { IssueFileCategories } from '~/types/components/IssueFileCategories'

export const CompanyFileCategoriesKeys: { [key in keyof Omit<CompanyFileCategories, 'id'>]: string } = {
  baseProspectus: 'baseProspectus',
  cashFlowStatement: 'cashFlowStatement',
  financialStatement: 'financialStatement',
  balanceSheet: 'balanceSheet',
  incomeStatement: 'incomeStatement',
  annualReport: 'annualReport',
  auditReport: 'auditReport',
  otherDocuments: 'otherDocuments',
}

export function buildFileCategoriesPopulate(keys: string[]) {
  return keys.reduce((acc, key) => {
    acc[key] = {
      populate: {
        files: {
          populate: { file: { fields: ['name', 'url'] } },
        },
      },
    }
    return acc
  }, {} as Record<string, unknown>) // TODO: fix any
}

export const IssueFileCategoriesKeys: { [key in keyof Omit<IssueFileCategories, 'id'>]: string } = {
  issueTermSheet: 'issueTermSheet',
  collateralInstruments: 'collateralInstruments',
  prospectusAmendment: 'prospectusAmendment',
  otherDocuments: 'otherDocuments',
  amendmentToTermSheet: 'amendmentToTermSheet',
}

export function populateCompanyDetails() {
  return {
    lustration: {
      populate: {
        insolvency: '*',
        liquidation: '*',
        unreliableVat: '*',
      },
    },
    identification: '*',
    blogs: {
      populate: {
        author: '*',
        poster: '*',
      },
    },
    contact: '*',
    financialResults: {
      populate: ['statements'],
    },
    statutory: '*',
    ownerships: '*',
    extendedDetail: '*',
    fileCategories: {
      populate: buildFileCategoriesPopulate(Object.keys(CompanyFileCategoriesKeys)),
    },
    businessCategory: '*',
    // issues: {
    //   publicationState: 'live',
    //   populate: {
    //     interestRate: '*',
    //   },
    // },
    heroSection: {
      populate: {
        image: '*',
        video: '*',
      },
    },
    news: '*',
  }
}

export async function getCompanyDetails(slug: string) {
  const data = await apiRequestWrapper<Strapi4ResponseSingle<Company>>('/companies', {
    filters: { slug: { $eq: slug } },
    populate: populateCompanyDetails(),
  })

  if (!data.data.length) {
    throw new Error('Company not found')
  }

  return data
}
